export default "__VITE_ASSET__B9GG0bc1__"